import {Component, Input, OnInit} from '@angular/core';
import {LoyaltySelfscanservicedetailService} from '../../../services/loyalty/loyalty-selfscanservicedetail.service';
import {KontableComponent} from '../../../modules/UIKit/components/kontable/kontable.component';
import {Router} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {Observable} from 'rxjs/Observable';
import {SelfScanService, SelfScanServiceDetail} from '../../../models/loyalty-selfScan-service.model';

@Component({
  selector: 'app-loyalty-self-scan-service-detail',
  templateUrl: './loyalty-self-scan-service-detail.component.html',
  styleUrls: ['./loyalty-self-scan-service-detail.component.css']
})
export class LoyaltySelfScanServiceDetailComponent implements OnInit {

  @Input() selfscanserviceId: number;
  newDataAvailable = false;
  serverPagination = KontableComponent.ServerPagination;
  selectFilter = KontableComponent.SelectFilter;
  customFilter = KontableComponent.CustomFilter;
  initialFilters = [];

  render = {
    datatable: false
  };

  constructor(
    public selfscanServiceDetail: LoyaltySelfscanservicedetailService,
    private router: Router,
    private translate: TranslateService
  ) { }

  ngOnInit() {

    if (this.selfscanserviceId) {
      this.initialFilters.push({key: 'self_scanning_service_id' , value: this.selfscanserviceId})
    }

    const TRANSLATIONS = this.translate.get([
      'common.status_notDeleted',
      'common.status_onlyDeleted',
      'common.status_onlySuspended'
    ]);

    Observable.zip(
      TRANSLATIONS

    ).subscribe(([t]) => {

      /*this.listStates = [];
      this.listStates.push({ label: '', value: null });
      this.listStates.push({ label: t['common.status_notDeleted'], value: '0' });
      this.listStates.push({ label: t['common.status_onlyDeleted'], value: '1' });

      this.listStatesBl = [];
      this.listStatesBl.push({ label: '', value: null });
      this.listStatesBl.push({ label: t['common.status_notDeleted'], value: '0' });
      this.listStatesBl.push({ label: t['loyalty.blacklist'], value: '1' });*/

      this.render.datatable = true;

    });

  }

  goBack() {
    this.router.navigate(['/loyalty/selfscanservice/']);
  }

  onOpen(selfscanservice: SelfScanServiceDetail) {
    this.router.navigate(['/loyalty/selfscanservicetrx/' + selfscanservice.id]);
  }



}



// WEBPACK FOOTER //
// ./src/app/views/loyalty/loyalty-self-scan-service-detail/loyalty-self-scan-service-detail.component.ts